import { Button } from '@/components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'

const carouselNavButtonClassName =
	'flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-card text-foreground transition-colors hover:bg-accent disabled:pointer-events-none disabled:opacity-40'

interface HorizontalCarouselNavProps {
	canScrollPrev: boolean
	canScrollNext: boolean
	onScroll: (direction: 'prev' | 'next') => void
}

export function HorizontalCarouselNav({ canScrollPrev, canScrollNext, onScroll }: HorizontalCarouselNavProps) {
	return (
		<div className='flex items-center gap-2'>
			<Button variant='secondary' size='icon' className='h-12 w-12' onClick={() => onScroll('prev')} disabled={!canScrollPrev} aria-label='Scroll previous'>
				<ChevronLeft className='h-4 w-4' />
			</Button>
			<Button variant='secondary' size='icon' className='h-12 w-12' onClick={() => onScroll('next')} disabled={!canScrollNext} aria-label='Scroll next'>
				<ChevronRight className='h-4 w-4' />
			</Button>
		</div>
	)
}
